export const OpportunityViewTabIndex = {
    OVERVIEW: 0,
    ACTIVITY: 1,
    LIST: 2,
    QUOTATION: 3, 
    
 };

 export enum Status {
    Active = 1,
    InActive = 2,
    Deleted = 3
}